export default "__VITE_ASSET__d1d275d0__"